import { render } from "./BannerEdit.vue?vue&type=template&id=8d637ec4&scoped=true"
import script from "./BannerEdit.vue?vue&type=script&lang=js"
export * from "./BannerEdit.vue?vue&type=script&lang=js"

import "./BannerEdit.vue?vue&type=style&index=0&id=8d637ec4&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d637ec4"]])

export default __exports__